import { useState } from "react";
import { createCollection, uploadImage } from "../../../api/axios";
import img from "../../../assets/upload_img_1.svg";
import FieldError from "../../../shared/FieldError/FieldError";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../../shared/Spinner/Spinner";
import styles from "./Card.module.scss";

const Card = () => {
  const formData = new FormData();
  const [loading, setLoading] = useState(false);

  // user from localstorage
  const user = localStorage.getItem("user");

  // input states
  const [bannerImg, setBannerImg] = useState("");
  const [collectionName, setCollectionName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [twitter, setTwitter] = useState("");
  const [discord, setDiscord] = useState("");
  const [facebookLink, setFacebookLink] = useState("");
  const [instagramLink, setInstagramLink] = useState("");
  const [tiktokLink, setTiktokLink] = useState("");
  const [lat, setLat] = useState(-73.7846);
  const [long, setLong] = useState(40.6811);
  const [ispublic, setIspublic] = useState(true);

  // errors
  const [bannerImgError, setBannerImgError] = useState("");
  const [collectionNameError, setCollectionNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [websiteError, setWebsiteError] = useState("");
  const [twitterError, setTwitterError] = useState("");
  const [discordError, setDiscordError] = useState("");
  const [facebookLinkError, setFacebookLinkError] = useState("");
  const [instagramLinkError, setInstagramLinkError] = useState("");
  const [tiktokLinkError, setTiktokLinkError] = useState("");
  const [latError, setLatError] = useState(-73.7846);
  const [longError, setLongError] = useState(40.6811);
  const [ispublicError, setIspublicError] = useState(true);

  // handle image upload
  const onImageUpload = async (e) => {
    formData.append("file", e.target.files[0]);
    formData.append("upload_preset", "o959yirs");

    const response = await uploadImage(formData);
    if (response.status === 200) {
      setBannerImg(response.data.url);
    } else {
      setBannerImg("error");
    }
  };

  // handle submit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!bannerImg) {
  //     setBannerImgError("Collection Image is required!");
  //   }
  //   if (!collectionName) {
  //     setCollectionNameError("Collection Name is required!");
  //   }
  //   if (!description) {
  //     setDescriptionError("Collection Description is required!");
  //   }
  //   if (!category) {
  //     setCategoryError("Category is required!");
  //   }
  //   if (!address) {
  //     setAddressError("Address is required!");
  //   }
  //   if (!website) {
  //     setWebsiteError("Website is required!");
  //   }
  //   if (!twitter) {
  //     setTwitterError("Twitter is required!");
  //   }
  //   if (!discord) {
  //     setDiscordError("Discord is required!");
  //   }
  //   if (!facebookLink) {
  //     setFacebookLinkError("Facebook Link is required!");
  //   }
  //   if (!instagramLink) {
  //     setInstagramLinkError("Instagram Link is required!");
  //   }
  //   if (!tiktokLink) {
  //     setTiktokLinkError("Tiktok Link is required!");
  //   }

  //   if (
  //     bannerImg &&
  //     collectionName &&
  //     description &&
  //     category &&
  //     address &&
  //     website &&
  //     twitter &&
  //     discord &&
  //     facebookLink &&
  //     instagramLink &&
  //     tiktokLink &&
  //     lat &&
  //     long &&
  //     ispublic
  //   ) {
  //     // clear errors
  //     setBannerImgError(null);
  //     setCollectionNameError(null);
  //     setDescriptionError(null);
  //     setCategoryError(null);
  //     setAddressError(null);
  //     setWebsiteError(null);
  //     setTwitterError(null);
  //     setDiscordError(null);
  //     setFacebookLinkError(null);
  //     setInstagramLinkError(null);
  //     setTiktokLinkError(null);
  //     setLoading(true);

  //     const parsed = JSON.parse(user);
  //     const payload = {
  //       userId: parsed._id,
  //       collectionName,
  //       collectionDescription: description,
  //       category: category,
  //       address: address,
  //       collectionWebsite: website,
  //       twitter: twitter,
  //       discord: discord,
  //       bannerImage: bannerImg,
  //       facebookLink,
  //       instagramLink,
  //       tiktokLink,
  //       lat,
  //       long,
  //       ispublic,
  //     };

  //     const response = await createCollection(payload);

  //     if (response.status === 200) {
  //       console.log(response);
  //       toast.success(response.data.message);
  //       setLoading(false);
  //     } else {
  //       console.log(response);
  //       toast.error(response.data.message);
  //       setLoading(false);
  //     }
  //   }
  // };

  return (
    <div className={styles.container}>
      <form 
      // onSubmit={handleSubmit}
      >
        {bannerImg && (
          <img src={bannerImg} alt="upload-logo" className={styles.preview} />
        )}
        {!bannerImg && (
          <div className={styles.upload}>
            <img src={img} alt="upload-logo" />
            <input type="file" name="uploadLogo" onChange={onImageUpload} />
            <p>
              Logo Image<span>*</span>
            </p>
            {/* {bannerImgError && <FieldError message={bannerImgError} />} */}
          </div>
        )}

        <div className={styles.field}>
          <label>
            Name<span>*</span>
          </label>
          <input
            type="text"
            placeholder="E.g My collection"
            value={collectionName}
            onChange={(e) => setCollectionName(e.target.value)}
          />
          {/* {collectionNameError && <FieldError message={collectionNameError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Description<span>*</span>
          </label>
          <textarea
            name="description"
            cols="30"
            rows="10"
            placeholder="Write few lines about your collection..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
          {/* {descriptionError && <FieldError message={descriptionError} />} */}
        </div>
        <div className={styles.field}>
          <label>
            Select Category<span>*</span>
          </label>
          <select
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="United States">Select</option>
            <option value="finance">Finance</option>
            <option value="finance">Finance</option>
            <option value="finance">Finance</option>
          </select>
          {/* {categoryError && <FieldError message={categoryError} />} */}
        </div>
        <div className={styles.field}>
          <label>Collection Website</label>
          <input
            type="text"
            placeholder="E.g www.eternal.com"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
          />
          {/* {websiteError && <FieldError message={websiteError} />} */}
        </div>
        <div className={styles.field}>
          <label>Twitter</label>
          <input
            type="text"
            placeholder="E.g @Azuki"
            value={twitter}
            onChange={(e) => setTwitter(e.target.value)}
          />
          {/* {twitterError && <FieldError message={twitterError} />} */}
        </div>
        <div className={styles.field}>
          <label>Discord</label>
          <input
            type="text"
            placeholder="E.g Azuki123"
            value={discord}
            onChange={(e) => setDiscord(e.target.value)}
          />
          {/* {discordError && <FieldError message={discordError} />} */}
        </div>
        <div className={styles.field}>
          <label>Address</label>
          <input
            type="text"
            placeholder="E.g Mrs Smith 813 Howard Street Oswego NY 13126 USA"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          {/* {addressError && <FieldError message={addressError} />} */}
        </div>
        <div className={styles.field}>
          <label>Facebook Link</label>
          <input
            type="text"
            placeholder="www.facebook.com/bored_apes"
            value={facebookLink}
            onChange={(e) => setFacebookLink(e.target.value)}
          />
          {/* {facebookLinkError && <FieldError message={facebookLinkError} />} */}
        </div>
        <div className={styles.field}>
          <label>Instagram Link</label>
          <input
            type="text"
            placeholder="www.instagram.com/bored_apes"
            value={instagramLink}
            onChange={(e) => setInstagramLink(e.target.value)}
          />
          {/* {instagramLinkError && <FieldError message={instagramLinkError} />} */}
        </div>
        <div className={styles.field}>
          <label>Tiktok Link</label>
          <input
            type="text"
            placeholder="www.tiktok.com/bored_apes"
            value={tiktokLink}
            onChange={(e) => setTiktokLink(e.target.value)}
          />
          {/* {tiktokLinkError && <FieldError message={tiktokLinkError} />} */}
        </div>
        <div className={styles.field}>
          <label>Public</label>
          <div className={styles.radioButtons}>
            <div className={styles.radio}>
              <label>
                <input
                  type="radio"
                  value={true}
                  checked={ispublic}
                  onChange={(e) => setIspublic(true)}
                />
                Yes
              </label>
            </div>
            <div className={styles.radio}>
              <label>
                <input
                  type="radio"
                  value={false}
                  checked={!ispublic}
                  onChange={(e) => setIspublic(false)}
                />
                No
              </label>
            </div>
          </div>
          {/* {ispublicError && <FieldError message={ispublicError} />} */}
        </div>
        <button type="button">
          {loading ? <Spinner /> : "Create Collection"}
        </button>
      </form>
    </div>
  );
};

export default Card;
